import { AreaApi } from '@wiz-api/area-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { RiskAreaGradeStatisticsApi } from '@wiz-api/huizhou2-business'
import { map, forEach, get, find, concat, fromPairs, isEmpty, findIndex, filter, assign, pick, cloneDeep, round, flatten, difference } from 'lodash'

const areaApi = new AreaApi()
const dataCategoryApi = new DataCategoryApi()
const abpApi = new AbpApplicationConfigurationApi()
const riskAreaGradeStatisticsApi = new RiskAreaGradeStatisticsApi()

/** ************************************************ 风险区域列表 **************************************** */
// 风险区域绘制实例列表
// 风险区域列表
let riskAreaList = []
let cloudRender
// 风险区域图标列表
const areaIconList = []
// const areaIconList = new Proxy([], {
//   set: (target, key, value) => {
//     if (key === 'length') {
//       if (value > 0) {
//         return true
//       }
//       cloudRender?.Marker.destroyMarker(map(target, 'id'))
//     }
//     target[key] = value
//     return true
//   },
//   get(target, property) {
//     return target[property]
//   }
// })
// 风险等级与绘制区域颜色的映射
let riskLevelColor = {}
const riskAreaInstance = []
// const riskAreaInstance = new Proxy([], {
//   set: (target, key, value) => {
//     if (key === 'length') {
//       if (value > 0) {
//         return true
//       }
//       // 清空数据时，销毁所有区域
//       player?.Native.Area3D.batchDestroyArea(flatten(map(target, (item) => {
//         return [item.areaObject, item.areaObject2]
//       })))
//     }
//     target[key] = value
//     return true
//   },
//   get(target, property) {
//     return target[property]
//   }
// })
let updateTimer = null
let signalId = null
let destroyTaskList = []

// 相关设置
const riskLevelMap =
  fromPairs(
    get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')?.riskLevelMap
  ) || []
const riskLevelEnum = {
  4: '重大风险',
  3: '较大风险',
  2: '一般风险',
  1: '低风险',
}
const getRiskLevelColor = (val) => {
  let color = ''
  switch (val) {
    case '重大风险':
      color = '#ff000066'
      break
    case '较大风险':
      color = '#ff6b0066'
      break
    case '一般风险':
      color = '#faff0080'
      break
    case '低风险':
      color = '#0057ff66'
      break
    default:
      color = 'ffffff00'
      break
  }
  return color
}
const eventQueue = []
let isDone = true
const processNextEvent = async () => {
  if (eventQueue.length === 0) {
    isDone = true
    return
  }
  isDone = false
  const event = eventQueue.shift()
  try {
    await event()
    processNextEvent()
  } catch (error) {
    processNextEvent()
  }
}

// 初始化数据
const initAreaData = () => {
  if (updateTimer) {
    clearInterval(updateTimer)
  }
  riskAreaInstance.length = 0
  riskAreaList = []
  areaIconList.length = 0
  riskLevelColor = {}
  updateTimer = null
  signalId = null
}

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}

// 打开风险区域详情
const openAreaDetail = (areaDetail) => {
  if (!areaDetail) {
    return
  }
  const openEvent = new CustomEvent('openComponent', {
    detail: {
      toCom: {
        code: 'RiskAreaDetails',
        origin: 'tag',
        name: areaDetail.name,
        originTagName: 'RiskArea',
      },
      type: 'tags',
      props: {
        areaDetail,
      },
    },
  })
  window.dispatchEvent(openEvent)
}

// 获取风险区域列表
const getAreaList = async (sceneId) => {
  const [err, res] = await areaApi.getList({
    modelId: sceneId,
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err && res) {
    return res.items
  }
  return []
}
// 获取风险区域静动态报警统计
const getRiskAreaGradeStatistics = async () => {
  const [err, res] = await riskAreaGradeStatisticsApi.getList({
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err) {
    return res.items
  }
  return []
}

// 获取风险等级列表
const getDicDataByCode = async () => {
  const [configError, abpConfigList] = await abpApi.get()
  if (!configError && !isEmpty(abpConfigList)) {
    const [statusError, statusRes] = await dataCategoryApi.getByCode({
      code: abpConfigList.setting.values['AreaManagement.DataCategory.RiskLevel'],
    })
    if (!statusError) {
      forEach(statusRes?.dataItems, (item) => {
        riskLevelColor[item.id] = item.code
      })
    }
  }
}
// 更新区域数据
const updateRiskData = async () => {
  const statistics = await getRiskAreaGradeStatistics()
  riskAreaList.forEach((item) => {
    const statisticsItem = find(statistics, ['riskAreaId', item.id])
    if (statisticsItem) {
      assign(item, pick(statisticsItem, ['includeWorkTicketIds', 'staticRiskGrade', 'maxRiskGrade', 'alarmCount', 'cameraIds', 'minRiskGrade', 'isDynamicRisk', 'isAlarm', 'riskAreaId']))
    }
  })
  riskAreaInstance.forEach((item) => {
    const statisticsItem = find(statistics, ['areaId', item.id])
    if (statisticsItem) {
      assign(item.areaDetail, pick(statisticsItem, ['includeWorkTicketIds', 'staticRiskGrade', 'maxRiskGrade', 'alarmCount', 'cameraIds', 'minRiskGrade', 'isDynamicRisk', 'isAlarm', 'riskAreaId']))
    }
  })
}
const getTexture = (areaDetail) => {
  let texture1 = ''
  let texture2 = ''
  // 存在动态风险，背景色为最高风险色，光柱为最低风险色
  if (areaDetail.isDynamicRisk) {
    texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/texture${areaDetail.minRiskGrade}.png`
    texture2 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/background.png`
    if (areaDetail.riskAreaId && (texture1 !== areaDetail.texture1 || texture2 !== areaDetail.texture2)) {
      return [texture1, texture2]
    }
    return []
  }
  // 不存在动态风险，背景色和光柱为区域风险色
  texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.staticRiskGrade]]}/background.png`
  if (areaDetail.riskAreaId && (texture1 !== areaDetail.texture1)) {
    return [texture1, texture1]
  }
  return []
}
// 更新区域动效
const updateAreaEffect = async (instanceItem) => {
  const areaDetail = instanceItem.areaDetail
  const areaObject = instanceItem.areaObject
  const areaObject2 = instanceItem.areaObject2
  // let texture1 = ''
  // let texture2 = ''
  // // 存在动态风险，背景色为最高风险色，光柱为最低风险色
  // if (areaDetail.isDynamicRisk) {
  //   texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/texture${areaDetail.minRiskGrade}.png`
  //   texture2 = areaDetail.isAlarm ? `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/alarmTexture${areaDetail.minRiskGrade}.png` : texture1
  // } else {
  //   // 不存在动态风险，背景色和光柱为区域风险色
  //   texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.staticRiskGrade]]}/texture${areaDetail.staticRiskGrade}.png`
  //   texture2 = areaDetail.isAlarm ? `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.staticRiskGrade]]}/alarmTexture${areaDetail.staticRiskGrade}.png` : texture1
  // }
  // if (areaDetail.riskAreaId && (texture1 !== areaDetail.texture1 || texture2 !== areaDetail.texture2)) {
  //   areaDetail.texture1 = texture1
  //   areaDetail.texture2 = texture2
  //   player.Native.Area3D.setAreaTexture(areaObject, texture1, texture2) // 设置区域贴图，两个贴图不同则实现闪烁效果
  // }

  // let texture1 = ''
  // let texture2 = ''
  // // 存在动态风险，背景色为最高风险色，光柱为最低风险色
  // if (areaDetail.isDynamicRisk) {
  //   if (areaDetail.isAlarm) {
  //     texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/background.png`
  //     texture2 = areaDetail.isAlarm ? `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.maxRiskGrade]]}/alarmBackground.png` : texture1
  //     if (areaDetail.riskAreaId && (texture1 !== areaDetail.texture1 || texture2 !== areaDetail.texture2)) {
  //       areaDetail.texture1 = texture1
  //       areaDetail.texture2 = texture2
  //       player.Native.Area3D.setAreaTexture(areaObject, texture1, texture2) // 设置区域贴图，两个贴图不同则实现闪烁效果
  //     }
  //   } else {
  //     const color = Number(getRiskLevelColor(riskLevelEnum[areaDetail.maxRiskGrade]).replace('#', '0x'))
  //     player.Native.Area3D.setOutsideColor(areaObject, color) // 设置区域外侧颜色
  //     player.Native.Area3D.setInsideColor(areaObject, color)// 设置区域内侧颜色
  //     player.Native.Area3D.setSideColor(areaObject, color) // 设置区域边线颜色
  //   }
  // } else if (areaDetail.isAlarm) {
  //   // 不存在动态风险，背景色和光柱为区域风险色
  //   texture1 = `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.staticRiskGrade]]}/background.png`
  //   texture2 = areaDetail.isAlarm ? `data://../apps/markers/${riskLevelMap[riskLevelEnum[areaDetail.staticRiskGrade]]}/alarmBackground.png` : texture1
  //   if (areaDetail.riskAreaId && (texture1 !== areaDetail.texture1 || texture2 !== areaDetail.texture2)) {
  //     areaDetail.texture1 = texture1
  //     areaDetail.texture2 = texture2
  //     player.Native.Area3D.setAreaTexture(areaObject, texture1, texture2) // 设置区域贴图，两个贴图不同则实现闪烁效果
  //   }
  // } else {
  //   const color = Number(getRiskLevelColor(riskLevelEnum[areaDetail.staticRiskGrade]).replace('#', '0x'))
  //   player.Native.Area3D.setOutsideColor(areaObject, color) // 设置区域外侧颜色
  //   player.Native.Area3D.setInsideColor(areaObject, color)// 设置区域内侧颜色
  //   player.Native.Area3D.setSideColor(areaObject, color) // 设置区域边线颜色
  // }
  const texture = getTexture(areaDetail)
  if (!isEmpty(texture)) {
    const [texture1, texture2] = texture
    areaDetail.texture1 = texture1
    areaDetail.texture2 = texture2
    player.Native.Area3D.setAreaTexture(areaObject, texture1, texture1) // 设置区域贴图，两个贴图不同则实现闪烁效果
    player.Native.Area3D.setAreaTexture(areaObject2, texture2, texture2) // 设置区域贴图，两个贴图不同则实现闪烁效果
    if (areaDetail.isDynamicRisk) {
      player.Native.Area3D.setAreaUVMoveSpeed(areaObject, [1, 0])
    } else {
      player.Native.Area3D.setAreaUVMoveSpeed(areaObject, [0, 0])
    }
    player.Native.Area3D.setAreaUseTexture(areaObject, true) // 设置使用贴图
    player.Native.Area3D.setAreaUseTexture(areaObject2, true) // 设置使用贴图
  }
}
// 绘制标签
const drawMarker = async (player, areaDetail) => {
  if (!player?.Native) return
  if (!areaDetail.isDisplayName) return
  const background = riskLevelColor[areaDetail.riskLevelId]
    ? riskLevelColor[areaDetail.riskLevelId]
    : 'sample'
  const index = findIndex(riskAreaInstance, ['areaId', areaDetail.id])
  const areaAabb = await player.Native.NodeProxy.getAabb(
    riskAreaInstance[index]?.areaObject
  )
  const pos = Aabb.faceCenter(areaAabb, 'Z')
  const singleOption = {
    id: getUUID(),
    pos,
    background,
    visible: true,
    nodeOffset: [0, -50],
    text: areaDetail.name,
    textColor: '#ffff00ff',
    hasTriangle: false,
  }
  const picId = getUUID()
  const pictureOption = {
    id: picId,
    pos,
    backgroundUrl: `data://../apps/markers/${riskLevelMap[areaDetail.riskLevelName]}/marker.png`,
    visible: true,
    nodeOffset: [-20, -50],
    imgSize: [30, 30],
  }
  // 文字
  const textRes = await cloudRender.Marker.createBySingleLine(singleOption)
  if (textRes.status) {
    const data = map(textRes.data, (item) => {
      return {
        id: item,
        areaId: areaDetail.id,
        type: 'single',
        areaDetail,
      }
    })
    areaIconList.push(...data)
  }
  // 图片
  const picRes = await cloudRender.Marker.createByPicture(pictureOption)
  if (picRes.status) {
    const data = map(picRes.data, (item) => {
      return {
        id: item,
        areaId: areaDetail.id,
        type: 'picture',
        areaDetail,
      }
    })
    areaIconList.push(...data)
  }
}

// 绘制风险区域
const drawRiskArea = async (player, areaDetail) => {
  console.log(areaDetail, 'areaDetail.name')
  // styleOptions = {
  //   type: 'riskArea',
  //   style: '#ffffff00', // 区域颜色设置透明，通过贴图背景形成区域颜色
  // }
  // if (!player.Native) return
  // const pos = map(JSON.parse(areaDetail.coordinate), (item) => {
  //   return [+item.x, +item.y, +item.z]
  // })
  // 创建一个只有侧边展示贴图的区域(需要贴图平移展示报警效果)
  // const areaObject = await player.Native.Area3D.createArea(4) // 创建多面体区域
  // 创建一个只展示顶面和底面的区域(无任何动效，与侧面区域组合成一个完整的区域)
  // const areaObject2 = await player.Native.Area3D.createArea(4) // 创建多面体区域
  // const instanceItem = { areaId: areaDetail.id, areaObject, areaObject2, areaDetail }
  // 缓存围栏绑定的数据id
  // riskAreaInstance.push(instanceItem)
  // await player.Native.Area3D.setBottomParam(areaObject, pos) // 设置底面坐标
  // await player.Native.Area3D.setBottomParam(areaObject2, pos) // 设置底面坐标
  // player.Native.Area3D.setBuildTop(areaObject2, true) // 设置显示顶面
  // player.Native.Area3D.setBuildSide(areaObject2, false) // 设置不显示侧面
  // player.Native.Area3D.setBuildBottom(areaObject, false) // 设置不显示低面
  // player.Native.Area3D.setHeight(areaObject, areaDetail.height || 2) // 设置区域高度
  // player.Native.Area3D.setHeight(areaObject2, areaDetail.height || 2) // 设置区域高度
  // const color = Number(styleOptions.style?.replace('#', '0x'))
  // await player.Native.Area3D.setOutsideColor(areaObject, color) // 设置区域外侧颜色
  // await player.Native.Area3D.setInsideColor(areaObject, color)// 设置区域内侧颜色
  // await player.Native.Area3D.setSideColor(areaObject, color) // 设置区域边线颜色
  // drawMarker(player, areaDetail)
  // updateAreaEffect(instanceItem)
  // 图片宽高比为8:7
  // const repeatY = 1 / (areaDetail.height || 2)
  // const repeatX = 8 * repeatY / 7
  // player.Native.Area3D.setAreaUVRepeat(areaObject, [repeatX || 2.4, repeatY]) // 设置贴图大小
  // player.Native.Area3D.setAreaUVRepeat(areaObject2, [repeatX || 2.4, repeatY]) // 设置贴图大小
  // player.Native.Area3D.setAreaUseTexture(areaObject, true) // 设置使用贴图
  // player.Native.Area3D.setAreaUseTexture(areaObject2, true) // 设置使用贴图
}

// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const areaInfo = find(areaIconList, (item) => {
      return item.id === e.markerId
    })
    if (areaInfo) {
      // 移动到视角
      openAreaDetail(get(areaInfo, 'areaDetail'))
    }
  }
}

// 风险区域点击事件
const eventSelected = (e) => {
  if (e.area) {
    const areaInfo = find(riskAreaInstance, (item) => {
      return item.areaObject === e.area || item.areaObject2 === e.area
    })
    // 不存在选中风险区域
    if (!areaInfo) {
      return
    }
    openAreaDetail(get(areaInfo, 'areaDetail'))
  }
}
const drawArea = async (signal, areaObjectList) => {
  eventQueue.push(async () => {
    await player.Native.Area3D.EventBatchCreateFinished.disconnect(drawArea)
    if (destroyTaskList.includes(signal)) {
      signalId = null
      destroyTaskList = difference(destroyTaskList, [signal])
      await player.Native.Area3D.batchDestroyArea(areaObjectList)
      return
    }
    // 只对最新一次任务做处理
    if (signal !== signalId) {
      signalId = null
      return
    }
    signalId = null
    const cloneRiskAreaList = cloneDeep(riskAreaList)
    let index = 0
    while (index < cloneRiskAreaList.length) {
      const item = cloneRiskAreaList[index]
      const areaDetail = {
        ...item,
        areaObject: areaObjectList[index * 2],
        areaObject2: areaObjectList[index * 2 + 1],
      }
      const instanceItem = { areaId: areaDetail.id, areaObject: areaDetail.areaObject, areaObject2: areaDetail.areaObject2, areaDetail }
      riskAreaInstance.push(instanceItem)
      drawMarker(player, areaDetail)
      // updateAreaEffect(instanceItem)
      index += 1
    }
    clearInterval(updateTimer)
    updateTimer = setInterval(async () => {
      if (!player?.Native) {
        clearInterval(updateTimer)
        return
      }
      await updateRiskData()
      riskAreaInstance.forEach((item) => {
        updateAreaEffect(item)
      })
    }, 5000)
    await cloudRender.Dispatch.on('Marker', markerClick)
    // 监听风险区域点击事件
    await player.Native.Area3D.EventArea3DPicked.connect(eventSelected)
  })
  if (isDone) {
    processNextEvent()
  }
}
// 销毁风险区域
const destroy = async (player) => {
  eventQueue.push(async () => {
    const cloneAreaIconList = cloneDeep(areaIconList)
    const cloneRiskAreaInstance = cloneDeep(riskAreaInstance)
    if (!player?.Native) {
      return
    }
    if (signalId) {
      const destroySignalId = signalId
      // 判断创建区域任务是否完成，未完成则取消
      const isCancel = await player.Native.Area3D.cancelTask(signalId)
      if (!isCancel) {
        destroyTaskList.push(destroySignalId)
        signalId = null
      }
    }
    initAreaData()
    if (!get(cloudRender, 'Marker')) return
    // 销毁图标
    await cloudRender.Marker.destroyMarker(map(cloneAreaIconList, 'id'))
    // 销毁风险区域绘制
    // cloneRiskAreaInstance.forEach((item) => {
    //   player.Native.Area3D.destroyArea(item.areaObject)
    //   player.Native.Area3D.destroyArea(item.areaObject2)
    // })
    await player.Native.Area3D.batchDestroyArea(flatten(map(cloneRiskAreaInstance, (item) => {
      return [item.areaObject, item.areaObject2]
    })))
    // 取消标签的事件监听
    await cloudRender.Dispatch.off('Marker', markerClick)
    // 取消风险区域事件监听
    await player.Native.Area3D.EventArea3DPicked.disconnect(eventSelected)
    await player.Native.Area3D.EventBatchCreateFinished.disconnect(drawArea)
  })
  if (isDone) {
    processNextEvent()
  }
}
// 创建风险区域
const create = async (player, sourceId, propCloudRender) => {
  await destroy(player)
  eventQueue.push(async () => {
    if (!player?.Native) {
      return
    }
    cloudRender = propCloudRender
    // 生成风险区域
    player.Native.Area3D.enableDepthTest(true)
    // 获取风险区域列表数据
    riskAreaList = await getAreaList(sourceId)
    riskAreaList = filter(riskAreaList, 'isDrawed')
    console.log(riskAreaList, 'riskAreaList')
    // 获取风险等级跟颜色对应
    await getDicDataByCode()
    const statistics = await getRiskAreaGradeStatistics()
    riskAreaList.forEach((item) => {
      const statisticsItem = find(statistics, ['riskAreaId', item.id])
      if (statisticsItem) {
        assign(item, pick(statisticsItem, ['includeWorkTicketIds', 'staticRiskGrade', 'maxRiskGrade', 'alarmCount', 'cameraIds', 'minRiskGrade', 'isDynamicRisk', 'isAlarm', 'riskAreaId']))
      }
    })
    const params = flatten(map(riskAreaList, (area) => {
      const repeatY = 1 / (area.height || 2)
      const repeatX = 8 * repeatY / 7
      const defaultParam = {
        type: 4,
        bottomParam: map(JSON.parse(area.coordinate), (item) => {
          return [+item.x, +item.y, +item.z]
        }),
        height: area.height || 2,
        uvRepeat: [repeatX || 2.4, repeatY],
        isUseTexture: true,
        visible: true,
      }
      const texture = getTexture(area)
      return [
        {
          ...defaultParam,
          isBuildTop: false,
          isBuildBottom: false,
          isBuildSide: true,
          textures: isEmpty(texture) ? [] : [texture[0], texture[0]],
          uvMoveSpeed: area.isDynamicRisk ? [1, 0] : [0, 0],
        },
        {
          ...defaultParam,
          isBuildTop: true,
          isBuildBottom: true,
          isBuildSide: false,
          textures: isEmpty(texture) ? [] : [texture[1], texture[1]],
          uvMoveSpeed: [0, 0],
        },
      ]
    }))
    // 通过信号来获取区域创建完成
    player.Native.Area3D.EventBatchCreateFinished.connect(drawArea)
    signalId = await player.Native.Area3D.batchCreateArea(params)
  })
  if (isDone) {
    processNextEvent()
  }
}
// 切换标签围栏显示隐藏
const toggleDisplay = async (player, type) => {
  // 设置围栏的显隐
  forEach(riskAreaInstance, async (item) => {
    await player.Native.Area3D.setVisible(item.areaObject, type)
    await player.Native.Area3D.setVisible(item.areaObject2, type)
  })
  cloudRender.Marker.updateBySingleLine(
    map(
      filter(areaIconList, (item) => {
        return item.type === 'single'
      }),
      (i) => {
        return {
          id: i.id,
          visible: type,
        }
      }
    )
  )
  cloudRender.Marker.updateByPicture(
    map(
      filter(areaIconList, (item) => {
        return item.type === 'picture'
      }),
      (i) => {
        return {
          id: i.id,
          visible: type,
        }
      }
    )
  )
}

// 隐藏风险区域及其标签
const hidden = async (player) => {
  await toggleDisplay(player, false)
}

// 重新显示风险区域及其标签
const display = async (player) => {
  await toggleDisplay(player, true)
}

// 移动视角到风险区域
const moveToArea = async (areaId) => {
  // 没有设置视角，那么默认移到区域的视角
  const area = find(riskAreaInstance, ['areaId', areaId])
  if (area) {
    const aabb = await player.Native.NodeProxy.getAabb(area.areaObject)
    await cloudRender.Camera.moveCamera('Aabb', [aabb[0], aabb[1]])
  }
}
export default { create, destroy, hidden, display, moveToArea, riskAreaInstance }
